import { SearchWithFilter } from "components/search";

const AdmPage = () => {
  return <SearchWithFilter />;
};

export default AdmPage;
